import type {RootStore} from '../RootStore';

export const withWarmup = async <T>(rootStore: RootStore, slug: string, fetchMethod: () => Promise<T>): Promise<T> => {
  const {warmupData} = rootStore.controllerParams.controllerConfig.wixCodeApi.window;
  const {flowAPI} = rootStore.controllerParams;
  if (flowAPI.environment.isSSR) {
    warmupData.set(slug, await fetchMethod());
  }
  return warmupData.get(slug) || fetchMethod();
};
